import { render, staticRenderFns } from "./tracking-vehicle.component.vue?vue&type=template&id=283dd3fc"
import script from "./tracking-vehicle.component.ts?vue&type=script&lang=ts&external"
export * from "./tracking-vehicle.component.ts?vue&type=script&lang=ts&external"
import style0 from "./tracking-vehicle.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports